import { render, staticRenderFns } from "./ComboboxTaskType.vue?vue&type=template&id=0d4fd129&scoped=true&"
import script from "./ComboboxTaskType.vue?vue&type=script&lang=js&"
export * from "./ComboboxTaskType.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxTaskType.vue?vue&type=style&index=0&id=0d4fd129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4fd129",
  null
  
)

export default component.exports